"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Injectable = void 0;

var dependency_life_time_1 = require("./dependency-life-time");

var dependency_collection_1 = require("./dependency-collection");

require("reflect-metadata");

function Injectable(descriptor) {
  return function (objectType) {
    if (!objectType) throw new Error('Can not decorate a null or undefined value.');
    descriptor = descriptor || {};
    descriptor.lifeTime = descriptor.lifeTime || dependency_life_time_1.DependencyLifeTime.Transient;
    var dependencies = Reflect.getMetadata("design:paramtypes", objectType) || [];
    (descriptor.collection || dependency_collection_1.DependencyCollection.globalCollection).register(objectType, descriptor.lifeTime, dependencies);
  };
}

exports.Injectable = Injectable;